import React, {useEffect, useRef, useState} from 'react';
import "./Menu.scss";
import SimpleLineIcon from "react-simple-line-icons";
import Swiper from 'react-id-swiper';
import 'swiper/swiper-bundle.css';
import {LazyBackground, Nav} from "../../Components";
import {CatsData, ProductData, ProductDetailData, RootData, StoreData} from "./MenuServices";
import {useHistory} from "react-router";
import SpeechRecognition, {useSpeechRecognition} from 'react-speech-recognition'
import {useSpeech} from "../../hooks";
import Tabs, {TabPane} from 'rc-tabs';
import '../../../node_modules/rc-tabs/assets/index.css';
import {useLocation} from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import Rodal from "rodal";


const styles = {
    slide: {
        padding: 15,
        minHeight: 100,
        color: '#fff',
    },
    slide1: {
        backgroundColor: '#FEA900',
    },
    slide2: {
        backgroundColor: '#B3DC4A',
    },
    slide3: {
        backgroundColor: '#6AC0FF',
    },
};


function SkeletonProduct({show}) {
    return (
        <div className="product-list">
            {show && [1, 2, 3, 4].map(item => {
                return (
                    <div className="menu-product-card">
                        <div className="menu-product-card-img">
                            <Skeleton width={'100%'} height={'100%'}/>
                        </div>
                        <span className="title"><Skeleton width={100}/></span>
                        <span className="price"><Skeleton width={30}/></span>
                    </div>
                )
            })}
        </div>
    )

}


function isEven(value) {
    if (value % 2 == 0)
        return true;
    else
        return false;
}

function Menu() {

    const speech = useSpeech();
    const CatRef = useRef(null);
    const MyRef = useRef(null);
    const location = useLocation();


    function callback(e) {
        setCurrentCat(e)
    }

    const CatClick = (cat) => {
        // console.log(cat)
        setCurrentPro(cat)
    }


    const paramsRoot = {
        slidesPerView: 3,
        spaceBetween: 0,
        rtl: true,
        // rebuildOnUpdate : true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }
    }


    const params = {
        slidesPerView: 4,
        spaceBetween: 0,
        rtl: true,
        // centeredSlides: true,
        // rebuildOnUpdate : true,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        }
    }

    const [preload, setPreload] = useState(true);
    const [failed, setFailed] = useState(false);
    const [search, setSearch] = useState("");
    const [allProducts, setAllProducts] = useState([]);

    const [originalList, setOriginalList] = useState([])
    const [list, setList] = useState([])
    const [products, setProducts] = useState([])


    const [cats, setCats] = useState([])
    const [allCats, setAllCats] = useState([])
    const [roots, setRoots] = useState([])
    const [all, setAll] = useState([])

    const [currentRootId, setcurrentRootId] = useState("");
    const [currentC, setCurrentC] = useState("");
    const [sklMode, setSklMode] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [productItem, setProductItem] = useState({});



    const setCurrentCat = (rootId) => {
        let cats = allCats.filter(cat => cat.parent.uid === rootId);
        cats.reverse();
        setCats(cats)
        setcurrentRootId(rootId)
        setTimeout(() => {
            if (CatRef.current) {
                CatRef.current.swiper.update();
            }
        }, 0)


        setCurrentC({uid: "0"})

        // let a1 = allCats.filter(cat=>cat.parent.uid===rootId).map(item=>item.uid);
        // let a2 = allProducts.filter(product=>{return a1.includes(product.parentUid)})
        let candidate_cats = allCats.filter(cat => cat.parent.uid === rootId);
        candidate_cats.forEach(cat => {
            let candidate_products = allProducts.filter(product => {
                return product.parentUid === cat.uid
            })
            cat['products'] = candidate_products;
        })

        setProducts([])
        candidate_cats.reverse();
        setAll(candidate_cats);


    }

    const setCurrentPro = (cat) => {
        let prod = allProducts.filter(p => p.parentUid === cat.uid);
        setCurrentC(cat)
        setProducts(prod)
        setAll([]);
    }

    const getAllCat = () => {
        getAllCatSub();
        // setCurrentC({uid:'0'})
        // let a1 = allCats.filter(cat=>cat.parent.uid===currentRootId).map(item=>item.uid);
        // let a2 = allProducts.filter(product=>{return a1.includes(product.parentUid)})
        //setProducts(a2);
    }

    const getAllCatSub = () => {
        setCurrentC({uid: '0'})
        let candidate_cats = allCats.filter(cat => cat.parent.uid === currentRootId);
        candidate_cats.forEach(cat => {
            let candidate_products = allProducts.filter(product => {
                return product.parentUid === cat.uid
            })
            cat['products'] = candidate_products;
        })

        setProducts([])
        candidate_cats.reverse()
        setAll(candidate_cats);
    }

    const searchList = (word) => {
        if (word.length < 1) {
            getAllCatSub();
            // let a1 = allCats.filter(cat=>cat.parent.uid===currentRootId).map(item=>item.uid);
            // let a2 = allProducts.filter(product=>{return a1.includes(product.parentUid)})
            // setProducts(a2);
        }
        if (word.length > 2) {
            let result = []
            allProducts.forEach(item => {
                if (item.name.includes(word)) {
                    result.push(item)
                }
            });
            setProducts(result)
            setAll([]);
        }
    }


    useEffect(() => {
        window.scrollTo(0, 0);
        checkRoot()
        if (location && location.state && location.state.event) {
            getRoot(location.state.event.uid);
        }

        if (location && location.state && location.state.item) {
            getRoot(location.state.item.merchantId);
        }
    }, [])


    const checkRoot = () => {
        // console.log("Item : ", location.state)
    }

    const getRoot = async (merchantUID) => {
        setSklMode(true);
        // console.log("EVENT : ", merchantUID)
        const response_root = await RootData(merchantUID);
        // console.log("root: ", response_root.data);
        if (response_root.data.length > 0) {
            response_root.data.reverse()
            setRoots(response_root.data);
            let cRootId = response_root.data[0].uid
            setcurrentRootId(cRootId);
            getCats(response_root.data, cRootId, merchantUID);
        }
    }

    const getCats = async (roots, rootId, merchantUID) => {
        let promises = [];
        roots.forEach(root => {
            promises.push(CatsData(merchantUID, root.uid))
        })

        const Cats = await Promise.all(promises);

        let all_cats = [];
        Cats.forEach(cats => {
            cats.data.forEach(cat => {
                all_cats.push(cat);
            })
        })

        setAllCats(all_cats)
        let cats = all_cats.filter(cat => cat.parent.uid === rootId);
        cats.reverse();
        setCats(cats);
        getProducts(all_cats, cats[0], rootId, merchantUID)
        // if(cats.length>4){
        //     getProducts(all_cats,cats[5])
        //     CatRef.current.swiper.slideTo(5);
        // }else {
        //     getProducts(all_cats,cats[0])
        // }

    }


    const getProducts = async (cats, initCat, rootId, merchantUID) => {
        let promises = [];
        setCurrentC(initCat)
        // console.log("Tes ", cats)
        cats.forEach(cat => {
            promises.push(ProductData(merchantUID, cat.uid))
        })

        const Products = await Promise.all(promises);

        let all_products = [];
        Products.forEach((pro, i) => {
            pro.data.results.forEach((p) => {
                all_products.push({name: p.name, image: p.image, price: p.price, uid: p.uid, parentUid: cats[i].uid});
            })
        })


        // console.log(all_products);


        setAllProducts(all_products)


        if (location && location.state && location.state.event) {

            //Set All ------------------------
            setCurrentC({uid: "0"})

            let candidate_cats = cats.filter(cat => cat.parent.uid === rootId);
            candidate_cats.forEach(cat => {
                let candidate_products = all_products.filter(product => {
                    return product.parentUid === cat.uid
                })
                cat['products'] = candidate_products;
            })

            setProducts([])
            candidate_cats.reverse();
            setAll(candidate_cats);
            //------------------------
        }

        if (location && location.state && location.state.item) {

            if (location.state.item.status === "cat") {

                //Set Buy Item ------------------------
                let Tag = location.state.item
                setcurrentRootId(Tag.cat.parent.uid)
                setCurrentC(Tag.cat.uid)

                let Tag_c = cats.filter(cat => cat.parent.uid === Tag.cat.parent.uid);
                cats.reverse();
                setCats(Tag_c)
                setcurrentRootId(Tag.cat.parent.uid)
                setTimeout(() => {
                    if (CatRef.current) {
                        CatRef.current.swiper.update();
                    }
                }, 0)

                let prod = all_products.filter(p => p.parentUid === Tag.cat.uid);
                setCurrentC(Tag.cat)
                setProducts(prod)
                setAll([]);
            }

            if (location.state.item.status === "all") {

                //Set Buy Item ------------------------
                let Tag = location.state.item
                setcurrentRootId(Tag.cat.parent.uid)

                setCurrentC({uid: "0"})

                let candidate_cats = cats.filter(cat => cat.parent.uid === Tag.cat.parent.uid);
                candidate_cats.forEach(cat => {
                    let candidate_products = all_products.filter(product => {
                        return product.parentUid === cat.uid
                    })
                    cat['products'] = candidate_products;
                })

                setProducts([])
                candidate_cats.reverse();
                setAll(candidate_cats);
            }


            if (location.state.item.status === "root") {
                //Set Buy Item ------------------------
                let Tag = location.state.item
                console.log("Root  ssssssssss: ",location.state.item)
                setcurrentRootId(Tag.cat.uid)

                setCurrentC({uid: "0"})

                let candidate_cats = cats.filter(cat => cat.parent.uid === Tag.cat.uid);
                candidate_cats.forEach(cat => {
                    let candidate_products = all_products.filter(product => {
                        return product.parentUid === cat.uid
                    })
                    console.log("Root : ",candidate_cats)
                    cat['products'] = candidate_products;
                })

                setProducts([])
                candidate_cats.reverse();
                setCats(candidate_cats)
                setAll(candidate_cats);
            }


        }


        // let prod = all_products.filter(p=> p.parentUid===initCat.uid);
        // setProducts(prod)
        // setAll([]);
        setSklMode(false);
    }

    const productClick = async (item) =>{
        setProductItem(item)
        setShowModal(true)
        try{
            let merchant = {};
            if (location && location.state && location.state.event) {
                merchant = location.state.event.uid
            }
            if (location && location.state && location.state.item) {
                merchant = location.state.item.merchantId
            }
            const response = await ProductDetailData(merchant,item.uid)

            setProductItem(response.data)

        }catch (e) {
            console.log(e)
        }
    }

    const RestrictText = (text)=>{
        if(text.length>20)
            return text.substr(0,20)+"..."

        return text
    }

    return (
        <div className="menu-container">
            <Rodal  customStyles={{width:'90%', height: 'auto',
                bottom: 'auto',
                top: '20%'}} animation={"zoom"} visible={showModal} showCloseButton={false} onClose={() => setShowModal(false)}>
                <div className="product-modal">
                    <img className="productItem-img" src={productItem.image} alt=""/>
                    <span className="productItem-name">{productItem.name}</span>
                    <span className="productItem-price">{productItem.price} ریال  </span>
                    <div className="productItem-desc">
                        <span>توضیحات</span>
                        {productItem && productItem.des?<p className={productItem.des.length>130?"product-item-scroll":""}>{productItem.des}</p>:null}
                    </div>
                </div>
            </Rodal>

            <div className="store-head">
                <div className="store-header" style={{paddingTop: 20}}>
                    {/*<i className="fa fa-bars"></i>*/}
                    <input
                        value={search}
                        onChange={(e) => {
                            setSearch(e.target.value)
                            searchList(e.target.value)
                        }}
                        type="text" name="" id="" placeholder="دنبال چی میگردی؟"/>
                    <div><SimpleLineIcon name="magnifier"/></div>
                </div>

                <div className="c-tabs" style={{marginTop: 55}}>
                    {roots.length > 0 ? <Swiper ref={MyRef}    {...paramsRoot}>
                            {roots.map(root => {
                                return (
                                    <div className={currentRootId === root.uid ? "c-tabs-item active" : "c-tabs-item"}
                                         onClick={() => {
                                             setCurrentCat(root.uid)
                                         }}>{root.name}</div>
                                )
                            })}
                        </Swiper> :
                        <>
                            {sklMode ? <div className="Skeleton">
                                <Skeleton width={100}/>
                                <Skeleton width={100}/>
                                <Skeleton width={100}/>
                            </div> : null}
                        </>
                    }
                </div>


                <div className="c-tabs cats-swiper">
                    {cats.length > 0 ? <Swiper dir={"rtl"} ref={CatRef}   {...params} >
                            <div className="cats_menu" onClick={() => getAllCat()}>
                                <img
                                    className={currentC.uid === '0' ? "active" : ""}
                                    src={"/other/merchant_logo.png"} alt=""/>
                                {"همه"}
                            </div>
                            {cats.map(cat => {
                                return (
                                    <div className="cats_menu" onClick={() => CatClick(cat)}>
                                        {cat.img ?
                                            <img src={cat.image} alt=""
                                                 className={currentC.uid === cat.uid ? "active" : ""}/> :
                                            <img src={cat.image} alt=""
                                                 className={currentC.uid === cat.uid ? "active" : ""}/>
                                        }
                                        {cat.name}
                                    </div>
                                )
                            })}
                        </Swiper> :
                        <>
                            {sklMode ? <div className="Skeleton">
                                <Skeleton circle={true} height={60} width={60}/>
                                <Skeleton circle={true} height={60} width={60}/>
                                <Skeleton circle={true} height={60} width={60}/>
                                <Skeleton circle={true} height={60} width={60}/>
                            </div> : null}
                        </>
                    }
                </div>

                {/*{cats.length>0?*/}
                {/*    <div className="menu-categories">*/}
                {/*        /!*OnlineStoreSubCat List*!/*/}
                {/*        <div className="store-categories-list">*/}
                {/*            {cats.length>0?  <Swiper  ref={CatRef}  {...params} shouldSwiperUpdate>*/}
                {/*                {cats.slice(0,5).map(cat=>{*/}
                {/*                    return (*/}
                {/*                        <div key={cat.uid}  className="menu-categories-item" onClick={()=>CatClick(cat)}>*/}
                {/*                            <img src={"https://s3.mobank.co/loyalty-media/product/product_category/images/kebab.jpg"} alt="" style={{width:'100%'}}/>*/}
                {/*                            <span>{cat.name}</span>*/}
                {/*                        </div>*/}
                {/*                    )*/}
                {/*                })}*/}
                {/*            </Swiper>:null}*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*    :null}*/}


                {products.length > 0 ?
                    <div className="product-wrapper-one">
                        <div className="cat-title">
                            <h3>{currentC.name}<i className="fa fa-database"></i></h3>
                        </div>
                        <div className={isEven(products.length) ? "product-list" : "product-list product-list-odd"}>
                            {products.map(item => {
                                return (
                                    <div className="menu-product-card" onClick={()=>{
                                        productClick(item)
                                    }}>
                                        {/*<img src={item.image} alt=""/>*/}
                                        {/*<div className="menu-product-card-img" style={{backgroundImage: `url(${item.image})`}}>*/}
                                        {/*</div>*/}
                                        <LazyBackground src={item.image}/>
                                        <span className="title">{item.name}</span>
                                        <span className="price">{`${item.price} ریال `}</span>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    : null}


                {products.length < 1 && all.length < 1 ?
                    <SkeletonProduct show={sklMode}/>
                    : null}

                {/*all products*/}
                <div className="product-wrapper">
                    {all.length > 0 && all.map(item => {
                        return (
                            <div>
                                {item.products.length > 0 ? <div className="cat-title">
                                    <h3>{item.name}<i className="fa fa-database"></i></h3>
                                </div> : null}
                                <div
                                    className={isEven(item.products.length) ? "product-list" : "product-list product-list-odd"}>
                                    {item.products.map(p => {
                                        return (
                                            <div className="menu-product-card" onClick={()=>{
                                                productClick(p)
                                            }}>
                                                {/*<div className="menu-product-card-img" style={{backgroundImage: `url(${p.image})`}}>*/}
                                                {/*</div>*/}
                                                <LazyBackground src={p.image}/>
                                                <span className="title" style={{direction:"rtl"}}>{RestrictText(p.name)}</span>
                                                <span className="price">{`${p.price} ریال `}</span>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        )
                    })}
                </div>

            </div>

            <Nav/>
        </div>
    )
}

export {Menu};
